"use client";

/**
 * İstemci bileşenleri markayı buradan alır. Değer kök layout'ta sunucudaki
 * `getBrand()` ile çözülüp `BrandProvider`'a verilir; istemci hiçbir zaman
 * markayı kendisi uydurmaz.
 *
 * Bu dosya yalnız bileşen/hook export eder (use client helper tuzağı).
 */
import { createContext, useContext, type ReactNode } from "react";
import type { Brand } from "@/lib/brand";
import { ENV_BRAND_NAME } from "@/lib/brand-constants";

const EMPTY_SOCIAL = { twitter: "", instagram: "", facebook: "", linkedin: "", youtube: "", telegram: "", whatsapp: "" };
const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL ?? "").replace(/\/+$/, "");

const CLIENT_FALLBACK: Brand = {
  name: ENV_BRAND_NAME,
  shortName: ENV_BRAND_NAME,
  siteUrl: SITE_URL,
  host: SITE_URL.replace(/^https?:\/\//, ""),
  logo: "",
  logoLight: "",
  logoDark: "",
  contactEmail: "",
  social: EMPTY_SOCIAL,
  twitterHandle: "",
};

const BrandContext = createContext<Brand>(CLIENT_FALLBACK);

export function BrandProvider({ brand, children }: { brand: Brand; children: ReactNode }) {
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand(): Brand {
  return useContext(BrandContext);
}
